import React, { MouseEventHandler, ReactNode } from 'react';
import Link from '@v2/shared/components/Link';

import useFooterMenu from './useFooterMenu';

/** headless: apps/topmags/layouts/MainLayout/Footer/FooterMenu. */
export default function FooterMenu() {
  const { menu } = useFooterMenu();

  const Heading = ({ children }: { children: ReactNode }) => (
    <h4 className="uppercase font-semibold text-gray-600 tracking-widest text-sm">{children}</h4>
  );

  // `onClick` is for the Do Not Sell entry, whose click opens CookieYes' preference
  // centre rather than following its href. Every other entry leaves it unset.
  const Item = ({
    href,
    onClick,
    children,
  }: {
    href: string;
    onClick?: MouseEventHandler<HTMLAnchorElement>;
    children: ReactNode;
  }) => (
    <Link href={href} className="text-sm text-gray-500 font-serif italic hover:underline" onClick={onClick}>
      {children}
    </Link>
  );

  return (
    <>
      {menu.map((section, index) => (
        <nav key={index} className="my-5 md:my-0">
          <Heading>{section.title}</Heading>
          <ul className="flex justify-center gap-3 md:gap-5 italic font-serif text-sm text-gray-500">
            {section.items.map((item, itemIndex) => (
              <li key={itemIndex}>
                <Item href={item.href} onClick={item.onClick}>
                  {item.title}
                </Item>
              </li>
            ))}
          </ul>
        </nav>
      ))}
    </>
  );
}
